import { Box, Button, Typography } from '@mui/material'
import React from 'react'

import { career1, career2, career3, career4 } from '../../../assets/images/Career';
import { ScrollFadeInSlideUp } from '../../../components';

const CareerDetails = () => {
    const opportunities = [
            {
                name:'internship', 
                image: career1,
                text:'Pangu summer intern program is an excellent way to explore the various career options within the construction industry.'
            },
            {
                name:'experienced',
                image:career2,
                text:'As an industry veteran, you have the knowledge and experience to hit the ground running with pangus Phelps.'
            },
            {
                name:'craft',
                image:career3,
                text:'As a craftsperson, you have skills we need and value. Our safety record\u2014more than twice as safe as the industry average\u2014reflects the value we put on our craft.'
            },
            {
                name:'facility Services',
                image:career4,
                text:'From entry level to industry veteran, grow your career in Facility Services.'
            }
        ]

    const SectionImage = ({image}) => {
        return (
            <Box
                component='img'
                src={image}
                sx={{
                    objectFit:'cover',
                    width:'30%'
                }}
            />
        )
    }

    const SectionText = ({title, text, sxTitle, sxText, index}) => {
        return (
            <Box
                sx={{
                    display:'flex',
                    flexDirection:'column',
                    width:'70%',
                    backgroundColor:'rgba(245, 245, 239, 1)',
                    paddingX:'3rem',
                    justifyContent:'center',
                    alignItems:'center'
                }}
            >
                <Box>
                    <Typography
                        sx={{
                            fontFamily:'var(--title-font)',
                            fontSize:'2rem',
                            fontWeight:'500',
                            textTransform:'capitalize',
                            textAlign: index % 2 === 0 ? 'left' : 'right' ,
                            ...sxTitle
                        }}
                    >{title}</Typography>

                    <Typography
                        sx={{
                            fontFamily:'var(--text-font)',
                            fontSize:'1.2rem',
                            textAlign: index % 2 === 0 ? 'left' : 'right',
                            ...sxText,
                            '@media screen and (max-width:762px)':{
                                fontSize:'1rem'
                            }
                        }}
                    >{text}</Typography>
                </Box>
                <Button
                    variant='outlined'
                    href='/contact'
                    sx={{
                        width:'30%',
                        marginY:'1rem',
                        borderColor:'var(--color-primary)',
                        backgroundColor:'var(--color-primary)',
                        color:'#000',
                        alignSelf:index % 2 === 0 ? 'flex-start' : 'flex-end',
                        '&:hover':{
                            borderColor:'var(--color-secondary)',
                            backgroundColor:'var(--color-secondary)',
                            color:'#fefefe'
                        },
                        '@media screen and (max-width:762px)':{
                            width:'70%'
                        }
                    }}
                >Join us Now!</Button>
            </Box>
        )
    }
  return (
    <Box
        sx={{
            display:'flex',
            flexDirection:'column',
            width:'100%',
            justifyContent:'center',
            alignItems:'center',
            margin:'0 auto',
            '@media screen and (max-width:762px)':{
                width:'100%'
            }
        }}
    >
        {opportunities.map((item, index) => (
            
            <Box
                sx={{
                    display:'flex',
                    flexDirection:'row',
                    marginY:'1rem',
                    width:'80%',
                    '@media screen and (max-width: 762px)':{
                        marginY:'0.5rem'
                    }
                }}
            >
            <ScrollFadeInSlideUp direction='left' threshold='0.7'>
                <Box
                    sx={{
                        display:'flex',
                        flexDirection:'row'
                    }}
                >
            {index % 2 === 0 ? (
                <>
                    <SectionImage image={item.image}/>
                    <SectionText title={item.name} text={item.text} index={index}/>
                </>
            ):(
                <>
                    <SectionText title={item.name} text={item.text} />
                    <SectionImage image={item.image}/>
                </>
            )}
            </Box>
            </ScrollFadeInSlideUp>
            </Box>
                
        ))}
    </Box>
  )
}

export default CareerDetails